import { interactionCardConfigSchemaProperties } from './interactionCard'

export const scratchCardConfigSchema = {
  type: 'object',
  properties: {
    ...interactionCardConfigSchemaProperties
  }
}
